import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {TrackInvitationsDetails} from '../../../Menus/TrackInvitationsDetails/trackInvitationsDetails.component';

@Component({
  selector: 'formly-field-file',
  template: `
    <input
      style="display:none"
      type="input"
      [formControl]="formControl"
      [formlyAttributes]="field"
    />
    <file-uploader
      [docId]="model.docId"
      [status]="props.status"
      [actionsflow]="props.actionsflow"
      (refresh)="refreshView()"
    ></file-uploader>
  `,
})
export class FormlyFieldFile extends FieldType {
  constructor(private track: TrackInvitationsDetails) {
    super();
  }

  refreshView() {
    let userId = localStorage.getItem('invId');
    this.track.getDocumentList(+userId);
  }
}
